module.exports = __webpack_public_path__ + "img/grow_1.69522f7e.png";